const DOC_TYPES = [
  'identity', 'selfie', 'visa', 'card_vitality',
  'proof_of_address', 'accommodation_of_address', 'hostIdentity',
];

const DOC_LABELS = {
  identity: "Pièce d'identité",
  selfie: 'Selfie',
  visa: 'Visa',
  card_vitality: 'Carte vitale',
  proof_of_address: 'Justificatif de domicile',
  accommodation_of_address: "Attestation d'hébergement",
  hostIdentity: "Pièce d'identité de l'hôte",
};

const MODAL_MAP = {
  selfie: 'ad_file_accept_simple',
  proof_of_address: 'ad_file_accept_simple',
  accommodation_of_address: 'ad_file_accept_simple',
  hostIdentity: 'ad_file_accept_simple',
  identity: 'ad_file_accept_identity',
  visa: 'ad_file_accept_visa',
  card_vitality: 'ad_file_accept_card_vitality',
};

const DOC_CONFIG = [
  { key: 'identity', subType: 'CNI', title: "Carte d'identité", match: (tw) => tw?.identity?.type === 'CNI' },
  { key: 'identity', subType: 'Passport', title: 'Passeport', match: (tw) => tw?.identity?.type !== 'CNI' },
  { key: 'selfie', title: 'Selfie' },
  { key: 'visa', title: 'Visa' },
  { key: 'card_vitality', title: 'Carte vitale' },
  { key: 'proof_of_address', title: 'Justificatif de domicile' },
  { key: 'accommodation_of_address', title: "Attestation d'hébergement" },
  { key: 'hostIdentity', title: "Pièce d'identité de l'hôte" },
];

module.exports = { DOC_TYPES, DOC_LABELS, MODAL_MAP, DOC_CONFIG };
